export function formatShipmentType(s: string | null | undefined) {
  if (!s) {
    return s;
  }

  if (s === 'I' || s === 'ID') {
    return 'ID';
  }
  if (s === 'D') {
    return 'D';
  }
  if (s === 'A.EDI') {
    return 'A.EDI';
  }

  return s
}

export function formatLclFcl(f:string|null|undefined) {
  if (f === 'L') {
    return 'Consol';
  } else if (f === 'F') {
    return 'FCL';
  } else if (f === 'O') {
    return 'LCL';
  }

  return f;
}

export function unFormatLclFcl(f:string|null|undefined) {
  if (f === 'Consol') {
    return 'L';
  } else if (f === 'FCL') {
    return 'F';
  } else if (f === 'LCL') {
    return 'O';
  }

  return '';
}

export function formatBlType(m:string|null|undefined) {
  if (!m) {
    return 'None';
  }

  if (m === 'A') {
    return 'Agent';

  } else if (m === 'D') {
    return 'Consol';
  } else if (m === 'C') {
    return 'Co-Load';
  } else if (m === 'N') {
    return 'Direct';
  }

  return m;
}


export function formatAEBlType(m:string|null|undefined) {
  let value = '';

  if (m === 'D') {
    value = 'Regular';
  } else if (m === 'C') {
    value = 'Consol';
  } else if (m === 'L') {
    value = 'Co-Load';
  }

  return value;
}

export function formatTrackingType(s: string | null | undefined, other: string | null | undefined) {
  let value = '';

  if (s === 'Q') {
    value = 'Start to Request';
  } else if (s === 'failed') {
    value = 'Invalid or Error';
  } else if (s === 'tracking_stopped') {
    if (other) value = other ?? '';
  } else if (s === 'pending') {
    value = 'Pending';
  } else if (s === 'awaiting_manifest') {
    value = 'Awaiting Manifest';
  } else {
    if (other) {
      if (other.includes('eta'))
        value = other.replaceAll('eta', 'ETA');
      else
        value = other ?? '';
    }
  }

  return value;
}
